module.exports = __webpack_public_path__ + "img/Ethiopia.7b6fc015.gif";